import $ from 'jquery';

export default class TemplateIndex {
  constructor(template) {
    this.el = template.el;
    this.$el = $(this.el);

    this.timeout = setTimeout(
      () => this.verticallyAlign()
      , 500,
    );

    $(window).on('resize.index', () => this.verticallyAlign());

    this.pictureBlocks = $('.picture-block', this.el);
  }

  verticallyAlign() {
    const $collections = $('.collection', this.el);

    for (let i = 0; i < $collections.length; i++) {
      const $collection = $($collections[i]);
      const $labels = $collection.find('h3, span');

      for (let j = 0; j < $labels.length; j++) {
        const $label = $($labels[j]);

        $label
          .css({ marginTop: $label.height() / -2 })
          .removeClass('preload');
      }
    }
  }

  unload() {
    clearTimeout(this.timeout);
    $(window).off('resize.index');
  }
}
